export const chains = {
    getList: () => axios.get('/admin/chains-list').then((res) => res.data),
}
